export enum PageFilterOperator {
  And = 'And',
  Or = 'Or'
}
